import styled from 'styled-components';
import { palette } from 'theme/MainTheme';
import { borderRadius } from 'library/helpers/style_utils';
import { MoreOutlined } from '@ant-design/icons';

const GenericDefaultCategoryDeviceCard = styled.div`
	display: flow-root;
	width: inherit;
	overflow: auto;
	margin-bottom: 4px;

	.stat {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}
	.customIcon {
		display: inline-block;
		margin-left: 5px;
		font-size: 24px;
	}
	.wordFix {
		overflow-wrap: break-word;
		max-width: 170px;
		display: flex;
	}

	.spanFix {
		cursor: pointer;
		max-width: 220px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		word-break: break-all;
		display: inline-block;
	}

	.btnActions {
		font-size: 8px;
		line-height: 8px;
	}
	.ant-card-actions > li {
		margin: 0;
	}

	.customFieldIcon {
		font-size: 12px;
		margin-left: 5px;
		align-items: center;
	}

	.uIDTooltop {
		display: flex;
		justify-content: flex-start;
	}
	.imageIcon {
		font-size: 12px;
	}
	.infoUID {
		font-size: 10px;
		font-weight: 400;
		opacity: 0.6;
		color: black;
	}

	.infoTitles {
		font-size: 10px;
		font-weight: 400;
		margin: 0 7px;
	}

	.infoValues {
		font-size: 10px;
		font-weight: 600;
		margin: 0 7px;
		margin-bottom: 5px;
		/* :first-child& {
			margin-left: 0;
		} */
	}

	.infoDivider {
		font-size: 14px;
		opacity: 0.6;
		color: black;
		margin-right: 5px;
		margin-left: 5px;
	}

	.infoLabel {
		font-size: 12px;
		font-weight: 500;
		opacity: 0.7;
		color: ${palette('primary', 8)};
		margin-right: 4px;
		margin-left: 5px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.ant-card-hoverable {
		cursor: default;
	}
	.infoActivityProp {
		font-size: 12px;
		font-weight: 400;
		opacity: 0.7;
	}

	.customCard {
		max-width: 315px;
		overflow: auto;
		background-color: ${palette('secondary', 7)};
		border-radius: 4px;
		border: 2px transparent solid !important;
	}

	.customCard:hover {
		border: 2px ${palette('secondary', 0)} solid !important;
	}
	.ant-card-bordered {
		border-color: ${palette('grayscale', 2)};
		width: 100%;
		${borderRadius()};
	}
	.ant-card-actions {
		border-bottom-left-radius: 3px;
		border-bottom-right-radius: 3px;
	}

	.ant-card-head {
		border-bottom-color: ${palette('grayscale', 3)};

		.ant-card-head-title {
			font-size: 18px;
			color: ${palette('secondary', 0)};
		}
		.ant-card-extra > span {
			font-size: 18px;
			padding: 10px;
			margin-right: -15px;
		}
	}

	.health-and-safety-card-content {
		display: flex;
		justify-content: start;
		flex-direction: column;

		.contact-container {
			font-size: 15px;
			font-weight: 500;
			text-transform: capitalize;
			padding-bottom: 5px;
		}
		.address-container {
			padding-left: 5px;
		}
	}
	.statsContainer {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: space-evenly;
		align-items: center;
		text-align: center;

		@media only screen and (max-width: 991px) {
			margin-top: 10px;
			justify-content: flex-start;
			align-items: flex-start;
		}
	}
	.ant-card-body {
		padding: 8px 12px !important;
	}

	.stat {
		min-width: 65px;
		display: flex;
		justify-content: flex-start;
	}

	.imageIcon {
		width: 15px;
		display: inline-block;
		margin-left: 5px;
		font-size: 14px;
	}
`;

const MoreOutlinedIcon = styled(MoreOutlined)`
	&:hover {
		cursor: pointer;
	}
`;

export { MoreOutlinedIcon };
export default GenericDefaultCategoryDeviceCard;
